const ValuePropsSection = () => {
  const values = [
    {
      icon: <i class="fi fi-sr-plant-care"></i>,
      title: 'Innovate sustainably',
      description: 'Optimize compositions and processes with fewer physical trials, lower material waste, reduced energy use, and a smaller development carbon footprint.',
      features: ['AI-driven optimization', 'Material waste reduction', 'Energy-efficient processes']
    },
    {
      icon: <i class="fi fi-ss-alarm-clock"></i>,
      title: 'Cut development time',
      description: 'Move from concept to prototype dramatically faster by simulating outcomes in hours instead of months.',
      features: ['Instant simulations', 'Virtual prototyping', 'Rapid iteration cycles']
    },
    {
      icon: <i class="fi fi-sr-handshake"></i>,
      title: 'Work collaboratively',
      description: 'Run simulations in the browser with no installation and share results in real time across teams.',
      features: ['Browser-based platform', 'Real-time collaboration', 'Secure cloud infrastructure']
    },
    {
      icon: <i class="fi fi-ss-microscope"></i>,
      title: 'Boost R&D efficiency',
      description: 'Explore more ideas with fewer resources and less technical risk.',
      features: ['Virtual testing', 'Resource optimization', 'Cost reduction']
    }
  ];

  return (
    <section className="value-props" id="benefits">
      <div className="value-container">
        <div className="section-header">
          <span className="section-label">Benefits</span>
          <h2 className="section-title">Accelerate Innovation, Reduce Costs</h2>
          <p className="section-subtitle">Transform your steel development process with our AI-powered platform</p>
        </div>
        <div className="value-grid">
          {values.map((value, idx) => (
            <div key={idx} className="value-card">
              <div className="icon-wrapper">
                <div className="value-icon">
                {value.icon}</div>
                <div className="icon-bg"></div>
              </div>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuePropsSection;
